export const LONG_DATE_FORMAT = new Intl.DateTimeFormat('en-US', {
  dateStyle: 'long',
});

/**
 * This formatter uses the `en-US` locale and ensures the output is
 * formatted in MM/DD/YYYY format (e.g., 11/22/2024). Dates are treated as UTC.
 */
export const dateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'UTC',
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
});
